/**
 * Constante con la ruta de la API de comunas
 */
export const COMUNAS = '/comunas';
export const PUBLIC = '/public';
